import React from 'react';
import Group from '@spa/shared/components/Filters/Group';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import { getCountrySlugFromLocation } from '@spa/shared/utils/countryTranslation';
import { FilterDescription } from '@spa/shared/components/Filters/Groups/styles';

const localRegistrationNamesByCountry = {
  spain: 'Empadronamiento',
  germany: 'Anmeldung',
  italy: 'Certificato di Residenza',
  portugal: 'Certificado de Registro',
  // eslint-disable-next-line quotes
  france: "Certificat d'immatriculation"
};

const getLocalRegistrationName = location => {
  const countrySlug = getCountrySlugFromLocation(location);

  return countrySlug && localRegistrationNamesByCountry[countrySlug]
    ? `(${localRegistrationNamesByCountry[countrySlug]})`
    : undefined;
};

const Registration = ({ fields, onChangeEventHandler, location = {} }) => {
  const { t } = useTranslation('translations');

  const localRegistrationName = getLocalRegistrationName(location);

  return (
    <Group title={t('filters.sections.registration')}>
      <FilterDescription>
        {t('filters.description.official_registration')}
        {localRegistrationName ? <span>{localRegistrationName}</span> : null}
      </FilterDescription>

      <CheckboxFilter
        name={'has-official-registration'}
        value={true}
        onChange={onChangeEventHandler}
        selected={fields['has-official-registration'] === 'true'}
        label={t('global.labels.registration_possible')}
      />
    </Group>
  );
};

Registration.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired,
  location: PropTypes.object
};

export default Registration;
